import * as React from "react";
import {useEffect, useState} from "react";
import {Button, Dimmer, Dropdown, Header, Icon, Input, Label, Loader, Modal} from "semantic-ui-react";
import {backend} from "../../../../../../xconvert-backend";
import {authentication} from "../../../../../../authentication";
import {Company, QueryRequest} from "../../../../../../generated";
import ReactTable from "react-table";
import {IfBox} from "../../../../../style/if";
import AceEditor from "react-ace";
import {SplitterHorizontal} from "../../../../../util/table-splitter-ui/src/components/Splitters/SplitterHorizontal";
import {Splitter} from "../../../../../util/table-splitter-ui/src/components/Splitters/Splitter";
import {normalizePath} from "../newNavTree/NavTree";

const jp = require('jsonpath');

enum FilterOperation {
    GreaterThan,
    GreaterThanEq,
    Equal,
    NotEqual,
    LowerThan,
    LowerThanEq,
    Contains,
    IsNull,
    NotNull
}

export interface OtherConfigFieldImplementationsModalProps {
    isOpen: boolean
    onClose: () => void
    path: string,
    matchValue?: string,
    notNull?: boolean,
    isContract?: boolean
}

export function OtherConfigFieldImplementationsModal(props: OtherConfigFieldImplementationsModalProps) {
    const openChangeCompanyModalEventName = "openChangeCompanyModalFromOtherImplementations";

    const [take, setTake] = useState(25);
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [query, setQuery] = useState<string>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [queryResponse, setQueryResponse] = useState<any>(null);
    const [error, setError] = useState<string | null>(null);
    const [selected, setSelected] = useState("");
    const [selectedRow, setSelectedRow] = useState<any>(null);

    function getInitialFilterOperation(): FilterOperation {
        if (props.matchValue !== undefined) {
            // matchValue wurde übergeben
            if (props.matchValue === null) {
                return FilterOperation.IsNull;
            } else {
                return FilterOperation.Equal;
            }
        } else if (props.notNull) {
            // notNull = true
            return FilterOperation.NotNull;
        }
        // kein Parameter gesetzt
        return FilterOperation.NotNull;
    }

    function getInitialFilterValue(): string {
        if (props.matchValue !== undefined && props.matchValue !== null) {
            return props.matchValue;
        }
        return "";
    }

    const [filterOperation, setFilterOperation] = useState<FilterOperation>(getInitialFilterOperation());
    const [filterValue, setFilterValue] = useState(getInitialFilterValue());

    useEffect(() => {
        const query = initiateQuery();
        queryExecuteCall(query).then();
    }, []);

    function handleClose() {
        props.onClose();
    }

    function fieldName() {
        const array = props.path.split(".");
        return array[array.length - 1];
    }

    function getOperatorString(operation: FilterOperation): string {
        switch (operation) {
            case FilterOperation.GreaterThan: return "GreaterThan";
            case FilterOperation.GreaterThanEq: return "GreaterThanEq";
            case FilterOperation.Equal: return "Equal";
            case FilterOperation.NotEqual: return "NotEqual";
            case FilterOperation.LowerThan: return "LowerThan";
            case FilterOperation.LowerThanEq: return "LowerThanEq";
            case FilterOperation.Contains: return "Contains";
            case FilterOperation.IsNull: return "IsNull";
            case FilterOperation.NotNull: return "NotNull";
            default: return "NotNull";
        }
    }

    function getFixedPath() {
        let path = normalizePath(props.path)

        // Determine if this is a contract or configuration
        const replacementString = props.isContract ? "-contracts.*" : "-configuration";

        path = path.replace("$", replacementString)
            .replace(/\.\d+\./g, ".*.");

        const pathArray = path.split(".");
        if (pathArray[pathArray.length - 1] == pathArray[pathArray.length - 2]) {
            pathArray.pop();
        }

        path = pathArray.join(".");

        console.log("FixedPath : ", path);
        return path;
    }

    function readValueOfPath(config: any, jsonPath: string) {
        console.log("[readValueOfPath] jsonPath -> ", jsonPath);

        try {
            const value = jp.value(config, jsonPath);
            console.log("[readValueOfPath] value -> ", value);
            console.log("[readValueOfPath] type -> ", typeof value);

            if (typeof value == "object") {
                return JSON.stringify(value, null, 4);
            }
            return value.toString();
        } catch (e) {
            console.log("EXCEPTION: ", e);
            return "N/A";
        }
    }

    function readValues(company: any) {
        console.log("READ VALUES for company -> ", company.tag);

        // For contracts, we need to handle the -contracts field which is an array
        const fieldKey = props.isContract ? "-contracts" : "-configuration";
        const replaceKey = props.isContract ? "Contracts" : "CompanyConfiguration";
        const fixedCompany = JSON.parse(JSON.stringify(company).replace(fieldKey, replaceKey));

        let config: any;
        if (props.isContract) {
            // For contracts, we need to access the Contracts array
            if (fixedCompany.Contracts != undefined) {
                console.log("Contracts ->", fixedCompany.Contracts);
                config = fixedCompany.Contracts;
            }
        } else {
            if (fixedCompany.CompanyConfiguration != undefined) {
                console.log("CompanyConfiguration ->", fixedCompany.CompanyConfiguration);
                config = fixedCompany.CompanyConfiguration;
            }
        }

        let jsonPath = JSON.parse(query).rules[0].field;

        const pathArray = jsonPath.split(".");
        if (pathArray[pathArray.length - 1] == pathArray[pathArray.length - 2]) {
            pathArray.pop();
        }

        jsonPath = pathArray.join(".");

        if (props.isContract) {
            jsonPath = "$." + jsonPath.replace(".Contracts", "").replace("-contracts.", "");
        } else {
            jsonPath = "$." + jsonPath.replace(".CompanyConfiguration", "").replace("-configuration.", "");
        }

        console.log("[readValues] jsonPath -> ", jsonPath);
        console.log("[readValues] config -> ", config);

        const values: string[] = [];

        if (jsonPath.includes(".*.")) {
            console.log("Array");
            let loopCount = 0;
            do {
                const value = readValueOfPath(config, jsonPath.replace(".*.", "[" + loopCount + "]."));
                if (value != "N/A") {
                    values.push(value);
                }
                loopCount++;
            } while (loopCount < 50 && values[values.length - 1] != "N/A" && values[values.length - 1] != undefined);
        } else {
            values.push(readValueOfPath(config, jsonPath));
        }

        return values;
    }

    function initiateQuery() {
        const path = getFixedPath();
        console.log("QueryENGINE requested with: ");
        const queryObj = {
            rules: [
                {
                    field: path,
                    value: filterValue,
                    operator: getOperatorString(filterOperation)
                }
            ],
            combinator: "and"
        };
        const queryStr = JSON.stringify(queryObj, null, 4);
        setQuery(queryStr);
        setIsLoading(false);
        return queryStr;
    }

    function initiateQueryWithParams(operation: FilterOperation, value: string) {
        const path = getFixedPath();
        const queryObj = {
            rules: [
                {
                    field: path,
                    value: value,
                    operator: getOperatorString(operation)
                }
            ],
            combinator: "and"
        };
        return JSON.stringify(queryObj, null, 4);
    }

    async function queryExecuteCall(queryParam = query, takeParam = take, pageParam = page) {
        const auth = backend.withTokenAuthHeader(authentication.token);

        const finalQuery = queryParam
            .replace(/"id": ".*",/gi, '')
            .replace(/"type": ".*",/gi, '');

        setIsLoading(true);
        setError(null);

        try {
            const params = {
                timeLimit: 60,
                bypassID: true,
                showhidden: true,
                wantedFields: [getFixedPath(), "name", "tag"]
            };

            const pagination = {
                limit: takeParam,
                skip: (pageParam - 1) * takeParam,
                sortBy: "_id",
                sortDirection: "DESC"
            };
            console.log(pagination);
            const request = {query: finalQuery, paginate: pagination, params: params} as QueryRequest;
            const response = await backend.queryApi.runQuery('Companies', request, auth);
            console.log(response);
            setQueryResponse(response.collectionWithPrivateFields.map(x => JSON.parse(x)));
            setCount(response.count);
            setTake(takeParam);
            setPage(pageParam);
        } catch (ex) {
            console.error("Error executing query:", ex);
            let errorMessage = "Query execution failed";
            if (ex.response) {
                errorMessage += ` (HTTP ${ex.response.status})`;
                if (ex.response.data) {
                    errorMessage += `: ${JSON.stringify(ex.response.data)}`;
                }
            } else if (ex.message) {
                errorMessage += `: ${ex.message}`;
            }
            setError(errorMessage);
            setQueryResponse(null);
        } finally {
            setIsLoading(false);
        }
    }

    async function changePage(pageIndex: number) {
        setIsLoading(true);
        setPage(pageIndex + 1);
        await queryExecuteCall(query, take, pageIndex + 1);
    }

    async function changePageSize(newSize: number) {
        setPage(1);
        setTake(newSize);
        setIsLoading(true);
        await queryExecuteCall(query, newSize, 1);
    }

    function renderQuery() {
        const operatorOptions = [
            { key: FilterOperation.GreaterThan, text: "GreaterThan", value: FilterOperation.GreaterThan },
            { key: FilterOperation.GreaterThanEq, text: "GreaterThanEq", value: FilterOperation.GreaterThanEq },
            { key: FilterOperation.Equal, text: "Equal", value: FilterOperation.Equal },
            { key: FilterOperation.NotEqual, text: "NotEqual", value: FilterOperation.NotEqual },
            { key: FilterOperation.LowerThan, text: "LowerThan", value: FilterOperation.LowerThan },
            { key: FilterOperation.LowerThanEq, text: "LowerThanEq", value: FilterOperation.LowerThanEq },
            { key: FilterOperation.Contains, text: "Contains", value: FilterOperation.Contains },
            { key: FilterOperation.IsNull, text: "IsNull", value: FilterOperation.IsNull },
            { key: FilterOperation.NotNull, text: "NotNull", value: FilterOperation.NotNull },
        ];

        return <div id={"OtherImplementationsQuery"} style={{
            height: '100%',
            padding: "1px",
            flexDirection: "column",
            display: "flex",
        }}>
            <div style={{ display: "flex", gap: "10px", marginBottom: "5px", alignItems: "center" }}>
                <Label style={{ minWidth: "60px" }}>Operator:</Label>
                <Dropdown
                    selection
                    value={filterOperation}
                    options={operatorOptions}
                    onChange={(e, data) => {
                        const newOp = data.value as FilterOperation;
                        setFilterOperation(newOp);
                        const newQuery = initiateQueryWithParams(newOp, filterValue);
                        setQuery(newQuery);
                    }}
                    style={{ flex: 1 }}
                />
                <Label style={{ minWidth: "60px" }}>Value:</Label>
                <Input
                    type="text"
                    value={filterValue}
                    onChange={(e) => {
                        const newVal = e.target.value;
                        setFilterValue(newVal);
                        const newQuery = initiateQueryWithParams(filterOperation, newVal);
                        setQuery(newQuery);
                    }}
                    style={{ flex: 1 }}
                    placeholder="Filter value"
                />
            </div>
            <AceEditor
                style={{
                    flex: "1",
                    flexGrow: 1,
                    minHeight: "100px"
                }}
                theme="monokai"
                mode='json'
                value={query}
                width="100%"
                height="100%"
                onChange={(e) => {
                    setQuery(e);
                }}
            />
        </div>;
    }

    function renderTable() {
        const columns: any[] = [
            {
                id: 'tag',
                Header: 'tag',
                width: 80,
                accessor: (d: any) => d.tag,
            },
            {
                id: 'companyName',
                Header: 'CompanyName',
                width: 300,
                accessor: (d: any) => d.name,
            }
        ];

        if (authentication.isSuperUser) {
            columns.push({
                id: 'switchCompany',
                Header: 'Action',
                width: 130,
                accessor: (d: any) => d._id,
                Cell: (row: any) => {
                    const company = row?.original as Company;
                    const canSwitch = company?._id != null;
                    return <Button
                        size="tiny"
                        primary
                        disabled={!canSwitch}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (canSwitch) {
                                props.onClose();
                                window.setTimeout(() => {
                                    window.dispatchEvent(new CustomEvent(openChangeCompanyModalEventName, {
                                        detail: {company}
                                    }));
                                }, 0);
                            }
                        }}
                    >
                        Switch
                    </Button>;
                }
            });
        }

        const indexedValues = new Map<string, string>();

        if (queryResponse != null) {
            queryResponse.forEach((company, c_index) => {
                try {
                    const values = readValues(company);
                    values.forEach((value, index) => {
                        const key = company._id + "_" + index;
                        indexedValues.set(key, value);
                        if (columns.find(c => c.id == 'field_' + index) == undefined) {
                            columns.push({
                                id: 'field_' + index,
                                Header: 'requested field[' + index + ']',
                                width: 500,
                                accessor: (d: any) => indexedValues.get(d._id + "_" + index),
                            });
                        }
                    });
                } catch (e) {
                    console.log("Error: " + e.message)
                }
            });
        }
        return <div style={{
            flex: 1,
            display: "flex",
            flexGrow: 1,
            flexDirection: "column",
            minHeight: "100px",
        }}>
            <Button
                style={{alignSelf: "center"}}
                onClick={() => queryExecuteCall()}
                primary
            >
                <Icon name={'search'} />
                run query
            </Button>
            <IfBox shouldShow={error != null}>
                <div style={{
                    padding: "20px",
                    margin: "10px",
                    backgroundColor: "#fff6f6",
                    border: "1px solid #e0b4b4",
                    borderRadius: "4px",
                    color: "#9f3a38"
                }}>
                    <Icon name="exclamation triangle" />
                    <strong>Error:</strong> {error}
                </div>
            </IfBox>
            <IfBox shouldShow={queryResponse != null}>
                <ReactTable
                    data={queryResponse}
                    pages={Math.ceil(count / queryResponse?.length)}
                    columns={columns}
                    sorted={[
                        {
                            id: 'createdAt',
                            desc: false
                        }
                    ]}
                    defaultPageSize={take}
                    className="-striped -highlight"
                    loading={isLoading}
                    getTdProps={(state, rowInfo, column, instance) => {
                        return {
                            onClick: () => {
                                if (rowInfo) {
                                    setSelected(rowInfo.row.field_0);
                                    setSelectedRow(rowInfo.row);
                                }
                            }
                        };
                    }}
                    getTrProps={(state, rowInfo) => {
                        return {
                            style: {
                                cursor: "pointer",
                                background: rowInfo && rowInfo.row._original._id === selectedRow?._original?._id ? '#00afec' : 'white'
                            }
                        };
                    }}
                    style={{cursor: "pointer"}}
                    onPageChange={(page) => changePage(page)}
                    onPageSizeChange={(pageSize) => changePageSize(pageSize)}
                    manual
                    page={page - 1}
                />
            </IfBox>
            <IfBox shouldShow={queryResponse == null && error == null}>
                <Dimmer active inverted>
                    <Loader inverted content='Loading'/>
                </Dimmer>
            </IfBox>
        </div>;
    }

    function drawLeftSide() {
        return <SplitterHorizontal
            name={"DbQuerySplitter"}
            top={renderQuery()}
            bottom={renderTable()}
        />;
    }

    function dropDownOptions() {
        const options = [];
        if (selectedRow != null) {
            Object.keys(selectedRow)
                .filter(key => key.startsWith("field_") && selectedRow[key] != null)
                .forEach((field, index) => {
                    options.push({key: index, text: field, value: selectedRow[field]});
                });
        }
        return options;
    }

    function drawRightSide() {
        return <div
            style={{
                flex: "1",
                display: "flex",
                flexDirection: "column",
                height: "100%",
            }}>
            <Dropdown
                placeholder='Select Field'
                fluid
                selection
                options={dropDownOptions()}
                onChange={(e, data) => {
                    setSelected(data.value.toString());
                }}
            />

            <AceEditor
                style={{
                    flex: "1",
                    display: "flex",
                }}
                theme="monokai"
                mode="groovy"
                value={selected}
                width="100%"
                readOnly={true}
            />
        </div>;
    }

    return <Modal
        open={props.isOpen}
        onClose={handleClose}
        size='fullscreen'
        dimmer={{className: 'contextMenuModalDimmer'}}
    >
        <Header icon='browser' content={'Other Implementations of ' + fieldName()}/>

        <Modal.Content
            style={{
                height: "calc(100vh - 100px)",
                flex: "1",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Splitter
                name={"OtherConfigFieldImplementationsModalVerticalSplitter"}
                left={drawLeftSide()}
                right={drawRightSide()}
            />
        </Modal.Content>
    </Modal>;
}
